
<template>

	<div ref="slider-wrapper" :class="{funnel}" :style="'--current-slide:'+(currentActiveScrollIndex || 0).toString()" class="wrapper wrapper-slider-plans pt-nav">
		<div class="container pt-small pb-default">
			<div class="row row-heading">
				<div class="col-12 centered">
					<h2 v-show="!funnel || trialAvailable" v-if="userStore?.currBusiness?.type === 'events'">{{ getString('title_page_prices_events') }}</h2>
					<h2 v-show="!funnel || trialAvailable" v-else>{{ getString('title_page_prices') }}</h2>
					<p class="heading-subtitle" v-html="getString('subtitle_page_prices')" v-if="trialAvailable"></p>
					<p class="heading-subtitle" v-html="getString('subtitle_page_prices_no_trial')" v-else></p>
				</div>
				<div class="col-12">
					<div class="row">
						<div class="col-12 centered switch-row">
							<AppSwitchNewDesign :label-item="0" :label="getString('plans_year_save', [currPlansSaving])" :items="[getString('capital_year'), getString('capital_month')]" :active-item="showMonthlyPrices ? 1 : 0" @switched="togglePricesPeriod" auto-switch />
						</div>
					</div>
				</div>
				<div class="col-12 col-12-cta" :class="{'two-cards': isTwoCards}">
					<div class="wrapper-cta">
						<div v-if="!isTwoCards" @click="setActiveSlide(0)" ref="cta-basic" :class="{active: currentActivePlanIndex === 0}" class="cta-nav">
							<p>{{ getString('basic_plan') }}</p>
						</div>
						<div @click="setActiveSlide(1, isTwoCards ? 0 : 1)" ref="cta-pro" :class="{active: currentActivePlanIndex === 1}" class="cta-nav">
							<p>{{ getString('pro_plan') }}</p>
						</div>
						<div @click="setCtaAllActiveSlide" ref="cta-all" :class="{active: currentActivePlanIndex === 2}" class="cta-nav">
							<p>{{ getString('allinone_plan') }}</p>
						</div>
					</div>
				</div>
			</div>
			<div class="row row-slider">
				<div class="wrapper-carousel">
					<div class="slider-carousel-plans" :class="{'two-cards': isTwoCards}">
						<MarketplaceNewSubscriptionCard v-show="!isTwoCards" :funnel="funnel" :month="showMonthlyPrices" :loading="loading || loadingSubscription" ref="card-basic" :class="{active: currentActivePlanIndex === 0}" :card="cardBasic" @clicked-cta="clickedCta('basic')" />
						<MarketplaceNewSubscriptionCard :funnel="funnel" :month="showMonthlyPrices" :loading="loading || loadingSubscription" ref="card-pro" :class="{active: currentActivePlanIndex === 1}" :card="cardPro" @clicked-cta="clickedCta('pro')" />
						<MarketplaceNewSubscriptionCard :funnel="funnel" :month="showMonthlyPrices" :loading="loading || loadingSubscription" ref="card-all" :class="{active: currentActivePlanIndex === 2}" :card="cardAllinone" @clicked-cta="clickedCta('allinone')" gradient />
					</div>
				</div>
			</div>
			<div class="row row-custom-plans">
				<MarketplaceNewSubscriptionCard :month="showMonthlyPrices" :loading="loading || loadingSubscription" horizontal :card="cardFree" @clicked-cta="clickedCta('free')"/>
			</div>
			<div class="row row-custom-plans" v-if="!funnel">
				<MarketplaceNewSubscriptionCard :month="showMonthlyPrices" :loading="loading || loadingSubscription" horizontal enterprise :card="cardEnterprise" @clicked-cta="clickedCta('enterprise')"/>
			</div>
		</div>
		<AppPopup :max-width="800" ref="popup-plans" :title="getString('title_pop_up_plans')">
			<PlansComparisonList />
		</AppPopup>
		<AppPopup ref="popup-confirm-cycle" :title="getString('change_billing_cycle')" :body-text="getString('change_billing_cycle_confirm', [this.userStore.currBusiness && this.userStore.currBusiness.plan_cycle === 'month' ? this.getString('monthly') : this.getString('yearly'), this.userStore.currBusiness && this.userStore.currBusiness.plan_cycle === 'month' ? this.getString('yearly') : this.getString('monthly')])" :buttons="[{text: getString('cancel'), negative: true}, {text: getString('continue'), callback: updateBillingCycle, loading: loadingSubscription}]" />
	</div>

</template>

<script>
import MarketplaceNewSubscriptionCard from "@/console-new/components/plugins/MarketplaceNewSubscriptionCard.vue";
import PlansComparisonList from "@/console-new/components/plugins/PlansComparisonList.vue";
import AppPopup from "@/shared/components/AppPopup.vue";
import {useLanguageStore, useNotificationStore, useSvgStore, useCurrencyStore} from "@/shared/stores";
import {useUserStore} from "@/console-new/stores";
import AppSwitchNewDesign from "@/shared/components/AppSwitchNewDesign.vue";
import API from "@/shared/helpers/API";

export default {
	emits: ["checkout", "switch-plan"],
	components: {AppSwitchNewDesign, MarketplaceNewSubscriptionCard, PlansComparisonList, AppPopup},
	setup() {
		let svgStore = useSvgStore();
		let userStore = useUserStore();
		let languageStore = useLanguageStore();
		let notificationStore = useNotificationStore();
		let currencyStore = useCurrencyStore();
		return {getIcon: svgStore.get, userStore, currencyStore, languageStore, getString: languageStore.getString, showNotification: notificationStore.showNotification}
	},
	name: "MarketplaceNewSubscriptionCards",
	props: {
		loading: {
			type: Boolean,
			default: false
		},
		funnel: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			currentActivePlanIndex: null,
			currentActiveScrollIndex: null,
			loadingSubscription: false,
			showMonthlyPrices: false,
		}
	},
	computed: {
		currPlansSaving() {
			let currSaving = this.currencyStore?.currCurrency?.prices?.plans?.year_save;
			return this.currencyStore.readableCurrencyValue(currSaving, false, true, true);
		},
		plansPrices() {
			return this.currencyStore.currCurrency?.prices?.plans || {};
		},
		cardFree() {
			return {
				planId: 'free',
				title: this.getString('free_plan'),
				description: this.getString('free_caption'),
				subtitle: this.getString('free_subtitle'),
				yearMonthPrice: 0,
				monthPrice: 0,
				functionalities: [
					{name: this.getString('business_package_counter'), available: true},
					{name: this.getString('digital_menu', [this.userStore.menuWord]), available: true},
					{name: this.getString('order_and_pay_by_qr'), available: false},
					{name: this.getString('functionality_tab_18'), available: false},
					{name: this.getString('functionality_tab_8'), available: false},
					{name: this.getString('abbreviated_kitchen_monitor'), available: false},
					{name: this.getString('terminal_fee', [this.localeNum(1.6, 1, '%')]), highlight: true},
				],
				funnelFunctionalities: [
					/*{name: this.getString('business_package_counter'), available: true},
					{name: this.getString('digital_menu', [this.userStore.menuWord]), available: true},*/
					{name: this.getString('terminal_fee', [this.localeNum(1.6, 1, '%')]), highlight: true},
				],
				readMoreCallback: this.togglePopupPlans,
			}
		},
		cardBasic() {
			return {
				planId: 'basic',
				title: this.getString('basic_plan'),
				description: this.getString('basic_caption'),
				subtitle: this.getString('basic_subtitle'),
				yearMonthPrice: this.plansPrices.basic?.yearMonth,
				monthPrice: this.plansPrices.basic?.month,
				functionalities: [
					{name: this.getString('business_package_counter'), available: true},
					{name: this.getString('digital_menu', [this.userStore.menuWord]), available: true},
					{name: this.getString('order_and_pay_by_qr'), available: false},
					{name: this.getString('functionality_tab_18'), available: false},
					{name: this.getString('functionality_tab_8'), available: false},
					{name: this.getString('abbreviated_kitchen_monitor'), available: false},
					{name: this.getString('terminal_fee', [this.localeNum(1.6, 1, '%')]), highlight: true},
				],
				funnelFunctionalities: [
					/*{name: this.getString('business_package_counter'), available: true},
					{name: this.getString('digital_menu', [this.userStore.menuWord]), available: true},*/
					{name: this.getString('terminal_fee', [this.localeNum(1.6, 1, '%')]), highlight: true},
				],
				readMoreCallback: this.togglePopupPlans,
			}
		},
		cardPro() {
			return {
				planId: 'pro',
				title: this.getString('pro_plan'),
				description: this.getString('pro_caption'),
				subtitle: this.getString('pro_subtitle'),
				yearMonthPrice: this.plansPrices.pro?.yearMonth,
				monthPrice: this.plansPrices.pro?.month,
				functionalities: [
					{name: this.getString('business_package_counter'), available: true},
					{name: this.getString('digital_menu', [this.userStore.menuWord]), available: true},
					{name: this.getString('order_and_pay_by_qr'), available: true},
					{name: this.getString('functionality_tab_18'), available: true},
					{name: this.getString('functionality_tab_8'), available: false},
					{name: this.getString('abbreviated_kitchen_monitor'), available: false},
					{name: this.getString('terminal_fee', [this.localeNum(1.4, 1, '%')]), highlight: true},
				],
				funnelFunctionalities: [
					/*{name: this.getString('plan_x', [this.getString('basic_plan')]), available: true},
					{name: this.getString('order_and_pay_by_qr'), available: true},
					{name: this.getString('functionality_tab_18'), available: true},*/
					{name: this.getString('terminal_fee', [this.localeNum(1.4, 1, '%')]), highlight: true},
				],
				readMoreCallback: this.togglePopupPlans,
			}
		},
		cardAllinone() {
			return {
				planId: 'allinone',
				title: this.getString('allinone_plan'),
				description: this.getString('allinone_caption'),
				subtitle: this.getString('allinone_subtitle'),
				yearMonthPrice: this.plansPrices.allinone?.yearMonth,
				monthPrice: this.plansPrices.allinone?.month,
				functionalities: [
					{name: this.getString('business_package_counter'), available: true},
					{name: this.getString('digital_menu', [this.userStore.menuWord]), available: true},
					{name: this.getString('order_and_pay_by_qr'), available: true},
					{name: this.getString('functionality_tab_18'), available: true},
					{name: this.getString('functionality_tab_8'), available: true},
					{name: this.getString('abbreviated_kitchen_monitor'), available: true},
					{name: this.getString('terminal_fee', [this.localeNum(1.2, 1, '%')]), highlight: true},
				],
				funnelFunctionalities: [
					/*{name: this.getString('plan_x', [this.getString('pro_plan')]), available: true},
					{name: this.getString('functionality_tab_8'), available: true},
					{name: this.getString('functionality_tab_7'), available: true},*/
					{name: this.getString('terminal_fee', [this.localeNum(1.2, 1, '%')]), highlight: true},
				],
				readMoreCallback: this.togglePopupPlans,
			}
		},
		cardEnterprise() {
			return {
				planId: 'enterprise',
				title: this.getString('enterprise_plan'),
				description: this.getString('enterprise_caption'),
				subtitle: this.getString('enterprise_subtitle'),
				yearMonthPrice: 'Custom',
				monthPrice: 'Custom',
				functionalities: [
					{name: this.getString('business_package_counter'), available: true},
					{name: this.getString('digital_menu', [this.userStore.menuWord]), available: true},
					{name: this.getString('order_and_pay_by_qr'), available: true},
					{name: this.getString('functionality_tab_18'), available: true},
					{name: this.getString('functionality_tab_8'), available: true},
					{name: this.getString('abbreviated_kitchen_monitor'), available: true},
				],
				readMoreCallback: this.togglePopupPlans,
			}
		},
		trialAvailable() {
			return this.userStore.user && this.userStore.user.stripe_trial !== 1 && this.userStore.currBusiness && !this.userStore.currBusiness.stripe_trial;
		},
		isTwoCards() {
			return !!this.funnel && this.userStore?.currBusiness?.type === 'events' && this.userStore?.currBusiness?.active_plan !== 'free' && this.userStore?.currBusiness?.active_plan !== 'basic';
		},
	},
	methods: {
		localeNum(value, fractionDigits = 1, appendSymbol = '') {
			return Number(value || 0).toLocaleString([this.languageStore.lang || 'en'], { minimumFractionDigits: fractionDigits }) + appendSymbol;
		},
		togglePricesPeriod() {
			this.showMonthlyPrices = !this.showMonthlyPrices;
		},
		togglePopupPlans(newValue) {
			this.$refs["popup-plans"].toggleStatus(!!newValue);
		},
		updateBillingCycle() {
			this.loadingSubscription = true;
			let newCycle = this.userStore.currBusiness && this.userStore.currBusiness.plan_cycle && this.userStore.currBusiness.plan_cycle === 'month' ? 'year' : 'month';
			API.init().stripeSubscriptionCycleUpdate(this.userStore.currBusinessId, newCycle, (response) => {
				this.userStore.refreshBusiness(this.userStore.currBusinessId,() => {
					this.loadingSubscription = false;
					if (response && response.result === "OK") {
						this.$refs["popup-confirm-cycle"].toggleStatus(false);
						this.showNotification('generic-success');
					} else {
						this.showNotification('generic-fail');
					}
				});
			});
		},
		clickedCta(plan) {
			if(plan === 'enterprise') {
				if (this.loadingSubscription) return;

				this.loadingSubscription = true;
				const demoUrl = 'https://qromo.pipedrive.com/scheduler/X9aapefr/qromo-book-a-free-consultation';
				let refAd = localStorage.getItem('referral_ad');

				API.init().sendCustomEvent('click_demo_enterprise', refAd, (response) => {
					window.location.href = demoUrl;
				});
			} else {
				if(!this.userStore.currBusiness.active_plan) {
					this.goLive(plan);
				} else if(this.userStore.currBusiness.active_plan !== plan) {
					let changeCycle = (this.showMonthlyPrices && this.userStore.currBusiness.plan_cycle === 'year') || (!this.showMonthlyPrices && this.userStore.currBusiness.plan_cycle === 'month');
					this.$emit("switch-plan", plan, changeCycle);
				} else if(this.userStore.currBusiness.active_plan === plan) {
					this.$refs["popup-confirm-cycle"].toggleStatus(true);
				} else {
					this.showNotification("generic-fail");
				}
			}
		},
		checkScreenWidth() {
			if(this.currentActivePlanIndex !== null) {
				if(!this.isTwoCards) {
					if (window.innerWidth < 1180) {
						if(this.currentActivePlanIndex < 2) {
							this.setActiveSlide(this.currentActivePlanIndex);
						} else {
							this.setCtaAllActiveSlide();
						}
					} else {
						this.setActiveSlide(null);
					}
				} else {
					if (window.innerWidth <= 768) {
						if(this.currentActivePlanIndex < 2) {
							this.setActiveSlide(this.currentActivePlanIndex, 0);
						} else {
							this.setCtaAllActiveSlide();
						}
					} else {
						this.setActiveSlide(null);
					}
				}
			}
		},
		setActiveSlide(slideIndex, scrollIndex = slideIndex) {
			this.currentActivePlanIndex = slideIndex;
			this.currentActiveScrollIndex = scrollIndex;
		},
		setCtaAllActiveSlide() {
			const screenWidth = window.innerWidth;
			if(!this.isTwoCards) {
				if (screenWidth <= 768) {
					this.setActiveSlide(2);
				} else if (screenWidth <= 1180) {
					this.setActiveSlide(2,1);
				} else {
					this.setActiveSlide(null);
				}
			} else {
				if (screenWidth <= 768) {
					this.setActiveSlide(2, 1);
				} else {
					this.setActiveSlide(null);
				}
			}
		},
		goLive(plan) {
			if(this.loadingSubscription) {
				return;
			}
			this.loadingSubscription = true;
			const billingCycle = this.showMonthlyPrices ? 1 : 0;
			this.userStore.subToPlan(plan, billingCycle, (client_secret, errDetails) => {
				if(client_secret === "partner") {
					this.showNotification("partner-subscription");
					this.userStore.refreshBusiness(this.userStore.currBusinessId, () => {
						this.loadingSubscription = false;
					});
				} else if(client_secret) {
					this.$emit("checkout", client_secret, billingCycle, plan);
					this.loadingSubscription = false;
				} else {
					let notificationName = errDetails === 'too_many_users' ? 'too-many-users' : 'generic-fail';
					if(errDetails === 'too_many_users') {
						let maxUsers = plan === 'basic' ? 3 : 10;
						maxUsers = plan === 'free' ? 1 : maxUsers;
						this.showNotification(notificationName, [maxUsers]);
					} else if(errDetails === 'no_webhooks') {
						this.showNotification('no-webhooks-edit');
					} else if(errDetails === 'max_webhooks') {
						this.showNotification('max-webhooks-edit', [1]);
					} else if(errDetails === 'currency_mismatch') {
						this.showNotification('user-currency-mismatch', [this.userStore?.user?.name]);
					} else {
						this.showNotification(notificationName);
					}
					this.loadingSubscription = false;
				}
			});
		},
	},
	mounted() {
		this.checkScreenWidth();
		window.addEventListener('resize', this.checkScreenWidth);
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.checkScreenWidth);
	},
	watch: {
		'userStore.currBusiness.plan_cycle': function (newVal) {
			this.showMonthlyPrices = newVal === 'month';
		},
		'userStore.currBusinessId': function (newVal) {
			this.checkScreenWidth();
		}
	}
}
</script>

<style scoped lang="scss">

:root {
	--current-slide: 0;
}

.wrapper-slider-plans {
	max-width: unset;

	.container {
		display: flex;
		flex-direction: column;
		.row-heading {
			display: flex;
			flex-direction: column;
			margin: 10px 0;
			p.heading-subtitle {
				text-align: center;
				background-image: var(--gradient-prices-green);
				-webkit-background-clip: text;
				-webkit-text-fill-color: rgba(0, 0, 0, 0);
			}
			.col-12 {
				@include breakpoint(tabletmini) {
					flex: 0 0 100%;
					width: 100%;
				}
				&-cta {
					justify-content: flex-end;
					align-items: flex-end;
					display: none;

					&:not(.two-cards) {
						@media (max-width: 1180px) {
							display: flex;
						}
					}
					&.two-cards {
						@media (max-width: 768px) {
							display: flex;
						}
					}
					.wrapper-cta {
						display: flex;
						gap: 15px;
						width: 100%;
						@media (max-width: 450px) {
							gap: 10px;
						}
						.cta-nav {
							padding: 10px 20px;
							background-color: var(--color-fill-button-table) ;
							border-radius: 13px;
							display: flex;
							justify-content: center;
							align-items: center;
							height: 45px;
							transition: background-color 0.3s ease;
							flex: 0 0 calc(33.33% - 10px);
							max-width: calc(33.33% - 10px);
							cursor: pointer;

							@media (max-width: 450px) {
								padding: 10px;
								flex: 0 0 calc(33.33% - 6.67px);
								max-width: calc(33.33% - 6.67px);
							}
							&:hover {
								background-color: var(--color-primary-alpha-4);
							}
							&.disabled {
								display: none;
							}
							&.active {
								cursor: default;
								background-color: var(--color-primary) ;
								p {
									color: var(--color-txt-white);
								}
							}
						}
					}
				}
			}
		}
		.row-slider {
			width: 100%;
			position: relative;
			overflow: hidden;
			margin: 0 auto;
			display: flex;
			align-items: stretch;
			justify-content: space-around;
			@media(max-width: 1180px) {
				width: calc(100% + var(--main-padding)*2);
				margin-left: calc(-1 * var(--main-padding));
			}
			.wrapper-carousel {
				padding: 0;
				width: 100%;
				position: relative;
				overflow: hidden;
				@media (max-width: 650px) {
					overflow: inherit;
				}
				.slider-carousel-plans {
					min-width: 100%;
					display: flex;
					transition: transform 0.5s;
					transform: translateX(calc(-33.33% * var(--current-slide)));
					gap: 20px;
					padding-bottom: 36px;
					padding-top: 22px;

					@media(max-width: 1260px) {
						gap: 6px;
						padding-bottom: 22px;
					}
					@media(max-width: 1180px) {
						transform: translateX(calc(-40% * var(--current-slide)));
						gap: 0;
						padding-bottom: 16px;
					}
					@media(max-width: 1080px) {
						gap: 4px;
						padding-bottom: 20px;
					}
					@media(min-width: 768px) and (max-width: 920px) {
						&:not(.two-cards) {
							padding-right: 16px;
						}
						&.two-cards {
							justify-content: center;
						}
					}
					@include breakpoint(tablet) {
						--card-width: calc(100% - 40px);
						transform: translateX(calc(var(--card-width) * -1 * var(--current-slide)));
					}
					@media (max-width: 450px) {
						--card-width: calc(100% - 20px);
						transform: translateX(calc(var(--card-width) * -1 * var(--current-slide)));
					}

					&.two-cards {
						@media(min-width: 768px) {
							transform: translateX(0) !important;
							gap: 20px;
							.card-carousel {
								padding-right: 0;
								padding-left: 0;
							}
						}
						@media(min-width: 921px) {
							justify-content: center;
						}
						.card-carousel:last-of-type {
							padding-right: 0;
						}
					}
				}
			}
		}

		.row-custom-plans {
			padding-bottom: 20px;
			.card-carousel {
				flex: 0 0 100%;
				max-width: 100%;
				.inside-wrapper {
					border-radius: 28px;
					background-color: var(--color-bg);
					width: calc(100% - 32px);
					height: calc(100% - 2px);
					position: relative;
					left: 20px;
					&:before {
						content: '';
						position: absolute;
						top: -1px;
						left: -9px;
						width: calc(100% + 10px);
						height: calc(100% + 2px);
						z-index: -1;
						background: var(--prices-bg-dark);
						border-radius: 29px;
						filter: blur(0);
						opacity: 1;
						transition: all 0.3s ease;
					}
					.wrapper-content {
						padding: 20px;
						display: flex;
						gap: 30px;
						.col-6 {
							flex: 0 0 calc(50% - 15px);
							max-width: calc(50% - 15px);
							display: flex;
							flex-direction: column;
							gap: 10px;
						}
					}
					&.active {
						background-color: var(--prices-bg-light-hover);
						&:before {
							top: -14px;
							height: calc(100% + 15px);
							@media(min-width: 1180px) {
								top: -9px;
								height: calc(100% + 10px);
							}
						}
						@media(min-width: 1180px) {
							background-color: var(--color-bg);
						}
					}
				}
			}
		}

	}
}

.switch-row {
	margin-top: 40px;

	.save-phrase {
		text-align: center;
		margin-bottom: 6px;
		color: var(--color-alpha-2);
		transition: color .3s $transition, font-size .3s $transition;
		font-size: 11px;

		&.active {
			color: var(--color-primary);
			font-size: 12px;
		}
	}

	@media (max-width: 1180px) {
		margin-bottom: 16px;
	}
}

</style>